/* survivalAnalysisSlice.ts */

/* Redux-Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

import { fetchSurvivalAnalysis } from "src/redux/thunks/survival-analysis/survivalAnalysisThunk";
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Interfaces */
import { BaseSliceProps } from "src/shared/interfaces/common/Slice";
import { SurvivalAnalysisProps } from "src/shared/interfaces/SurvivalAnalysis";

const initialState: BaseSliceProps<
  BaseChartProps<SurvivalAnalysisProps, ChartType[]>
> = {
  data: undefined,
  isLoading: false,
  modifiedAt: undefined,
  error: undefined,
};

export const survivalAnalysisSlice = createSlice({
  name: "survivalAnalysis",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchSurvivalAnalysis.pending,
      (state) => {
        if (!state.data) {
          state.isLoading = true;
          state.error = undefined;
        }
      }
    );
    builder.addCase(
      fetchSurvivalAnalysis.fulfilled,
      (
        state,
        action: PayloadAction<
          | BaseChartProps<
              SurvivalAnalysisProps,
              ChartType[]
            >
          | undefined
        >
      ) => {
        const prevData = state.data;
        state.data = action.payload;

        if (
          prevData &&
          JSON.stringify(prevData) !==
            JSON.stringify(state.data)
        ) {
          state.modifiedAt = new Date().toISOString();
        }

        if (state.data) {
          state.isLoading = false;
        }
      }
    );
    builder.addCase(
      fetchSurvivalAnalysis.rejected,
      (state, action) => {
        state.isLoading = false;
        state.data = undefined;

        const error = action.payload;
        if (!error) return;

        state.error = action.payload;
      }
    );
  },
});

/* Reducer */
export default survivalAnalysisSlice.reducer;
